import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import { getTemplateString } from 'common/helpers/string';
import OTPInput from 'components/OTPInput/OTPInput';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import {
  RESEND_CODE_STATUS,
  TIME_TO_CODE_RESEND,
  TIMEZONE_OFFSET,
} from 'templates/LoginPageData/forms/OTPVerification/OTPVerification';
import { fetcher } from 'app/http';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import { useAppDispatch } from 'app/hooks';
import { setContent } from 'features/content/reducer';
import PageLink from 'components/PageLink/PageLink';
import { OpenChatBot } from 'utils/chatBot';
import styles from './RegistrationVerifyOtpPageData.module.scss';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import { formProgression } from 'common/helpers/Gtm';

type Props = {
  Model: any;
  PageData: any;
  LayoutModel?: any;
};

const RegistrationVerifyOtpPageData = ({ Model, PageData, LayoutModel }: Props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [disableResend, setDisableResend] = useState<boolean>(false);
  const [counter, setCounter] = useState<number>(TIME_TO_CODE_RESEND);
  const [statusMessage, setStatusMessage] = useState<string>('');
  const [showCounter, setShowCounter] = useState<boolean>(false);
  const [showResendSuccess, setShowResendSuccess] = useState<boolean>(false);
  const [showStrugglingPopUp, setShowStrugglingPopUp] = useState<boolean>(
    Model?.ShowStrugglingPopUp,
  );
  const [showResendError, setShowResendError] = useState<boolean>(false);
  const [verificationFailureCount, setVerificationFailureCount] = useState(
    Model?.FormModel?.VerificationFailureCount,
  );
  // Template strings and tokens
  const sendSmsCodeText = getTemplateString(PageData?.SentSmsCodeNoteText);
  const sendEmailCodeText = getTemplateString(PageData?.SentEmailCodeNoteText);
  const mobileNumberToken = Model?.FormModel?.MobileNumber;
  const emailAddressToken = Model?.FormModel?.EmailAddress;
  const [otpValue, setOtpValue] = useState(['', '', '', '', '', '']);
  const [eventTracked, setEventTracked] = useState<boolean>(false);
  const [isOTPSubmitted, setIsOTPSubmitted] = useState<boolean>(false);
  const {
    control,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      FormModel: {
        ProfileId: Model?.FormModel?.ProfileId,
        DebtReference: Model?.FormModel?.DebtReference,
        MobileNumber: Model?.FormModel?.MobileNumber,
        VerificationFailureCount: Model?.FormModel?.VerificationFailureCount,
        key: Model?.FormModel?.key,
        EmailAddress: Model?.FormModel?.EmailAddress,
        AuthId: Model?.FormModel?.AuthId,
        Code1: '',
        Code2: '',
        Code3: '',
        Code4: '',
        Code5: '',
        Code6: '',
      },
    },
    mode: 'all',
  });

  var tagManagerArgs: any;
  useEffect(() => {
    if (eventTracked == false) {
      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Registration',
          checkout_step_number: '3'
        }
      };
      TagManager.dataLayer(tagManagerArgs);
      if (Model?.IsMobileOtpVerification) {
        tagManagerArgs = {
          dataLayer: {
            event: 'verification_init',
            checkout_name: 'Registration',
            verification_method: 'Phone'
          },
        };
        TagManager.dataLayer(tagManagerArgs);
      };
      if (!Model?.IsMobileOtpVerification) {
        tagManagerArgs = {
          dataLayer: {
            event: 'verification_init',
            checkout_name: 'Registration',
            verification_method: 'Email'
          },
        };
        TagManager.dataLayer(tagManagerArgs);
      };
      setEventTracked(true);
    }
  }, [eventTracked]);

  useEffect(() => {
    if (Model?.VerificationFailure == true) {
      tagManagerArgs = {
        dataLayer: {
          event: 'form_error',
          checkout_name: 'Registration',
          error_message: 'Incorrect OTP'
        }
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }, [Model?.VerificationFailure]);

  const onFormSubmit = handleSubmit(async (data: any) => {
    // onSubmit(data);
    try {
      setIsOTPSubmitted(true);
      data.FormModel.VerificationFailureCount = verificationFailureCount;
      const response = await fetcher.post(
        Model?.PostCodeLink,
        qs.stringify(data),
      );

      if (response?.data?.RedirectUrl) {
        const redirectPath = getPathnameFromUrl(response?.data?.RedirectUrl);
        const responseFromRedirect = await fetcher.get(redirectPath);
        if (responseFromRedirect?.data) {
          dispatch(setContent({ [redirectPath]: responseFromRedirect.data }));
          history.push(redirectPath, { noRefresh: true });
        }
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setIsOTPSubmitted(false);
    }
  });

  const handleOTPChange = (e: any, callback: Function) => {
    var oldValue = getValues(e.target.name);
    if (e.target.nextSibling && e.target.value) {
      e.target.nextSibling.focus();
    }
    if (e.target.value.length == otpValue.length) {
      handleOtpPaste(e);
    }
    else if (e.target.value.length > (e.target.maxLength + 1)) {
      return;
    }
    else if (e.target.value.length > e.target.maxLength) {
      var reminder = e.target.value % 10;
      var quotient = e.target.value / 10;

      if (reminder == oldValue) {
        e.target.value = Math.trunc(quotient);
      }
      else {
        e.target.value = reminder;
      }
    }

    callback(e.target.value);
  };

  const handleOtpPaste = (e: any) => {
    let paste = e.target.value;
    paste = paste.split('');
    setOtpValue(paste);
  };

  useEffect(() => {
    setValue('FormModel.Code1', otpValue[0]);
    setValue('FormModel.Code2', otpValue[1]);
    setValue('FormModel.Code3', otpValue[2]);
    setValue('FormModel.Code4', otpValue[3]);
    setValue('FormModel.Code5', otpValue[4]);
    setValue('FormModel.Code6', otpValue[5]);
  }, [otpValue]);

  const onResendCode = async (emailAddress?: string, mobileNumber?: string) => {
    try {
      setDisableResend(true);
      if (Model?.IsMobileOtpVerification) {
        tagManagerArgs = {
          dataLayer: {
            event: 'verification_send_again',
            checkout_name: 'Registration',
            verification_method: 'Phone'
          }
        };
        TagManager.dataLayer(tagManagerArgs);
      }
      if (!Model?.IsMobileOtpVerification) {
        tagManagerArgs = {
          dataLayer: {
            event: 'verification_send_again',
            checkout_name: 'Registration',
            verification_method: 'Email'
          }
        };
        TagManager.dataLayer(tagManagerArgs);
      }
      const data = qs.stringify({
        email: emailAddress,
        mobile: mobileNumber,
        key: Model?.FormModel?.key,
        debtReference: Model?.FormModel?.DebtReference,
        profileId: Model?.FormModel?.ProfileId,
        timezoneOffsetInMinutes: TIMEZONE_OFFSET,
      });
      const response = await fetcher.post(Model?.ResendCodeLink, data);
      if (response.data) {
        const { data } = response;
        if (data.status === RESEND_CODE_STATUS.OK) {
          setShowResendSuccess(true);
        }
        if (data.status === RESEND_CODE_STATUS.ERROR) {
          setDisableResend(false);
          setShowResendError(true);
          setStatusMessage(data?.message);
        }
        if (data.status === RESEND_CODE_STATUS.REDIRECT) {
          history.push(data.data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (showCounter) {
      const timer = setInterval(() => {
        if (counter > 0) {
          setCounter(counter - 1);
        } else {
          setShowCounter(false);
          setDisableResend(false);
          setCounter(TIME_TO_CODE_RESEND);
        }
      }, 1000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [counter, showCounter]);

  useEffect(() => {
    if (showResendSuccess) {
      const timer = setTimeout(() => {
        setShowResendSuccess(false);
        setShowCounter(true);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showResendSuccess]);

  useEffect(() => {
    setVerificationFailureCount(Model?.FormModel?.VerificationFailureCount);
    setShowStrugglingPopUp(Model?.ShowStrugglingPopUp);
  }, [Model]);

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length > 0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

  const liveBtn = () => {
    // OpenChatBot;
    OpenChatBot(Model?.WebchatPageUrl, PageData?.AnyQuestionsButtonText);
  };

  return (
    <>
      <div className="u-marginBxxsm u-marginTxxsm">
        <div className="step-wizard">
          <div className={styles.stepWizardContainer}>
            {
              // TODO: Handle that during integration
            }
            <a href="javascript:history.go(-1)" className={styles.prevBtn}>
              <Icon type={SvgIcons.CHEVRON_ICON} width={8} />
            </a>
            <p className="u-textCenter">
              {PageData?.StepText} <span className="u-textWeightBold">3</span>{' '}
              {PageData?.OfText} <span className="u-textWeightBold">4</span>
            </p>
            <a
              id="cancelregistration"
              data-modal-url="@Model.CancelRegistrationPageUrl"
              className={styles.cancelBtn}
            >
              <Icon type={SvgIcons.CLOSE} width={16} />
            </a>
          </div>
        </div>
      </div>
      <section className="Section">
        <div className="Page-container PageContainer--transparent">
          <div className="auth0-container">
            <div className="auth0-wrapper">
              <div className="form-heading">
                {PageData?.TypeInYourCodeLabel}
              </div>
              <div>
                <p className="form-text">
                  {Model?.IsMobileOtpVerification ? (
                    <>
                      {sendSmsCodeText && (
                        <p className="textleftmobile">
                          {sendSmsCodeText({ MobileNumber: mobileNumberToken })}
                          <PageLink
                            url={Model?.MobileNumberVerificationLink}
                            text={PageData?.GoingBackLinkText}
                            className="u-textWeightBold u-textdecoration"
                          />
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      {sendEmailCodeText && (
                        <p className="textleftmobile">
                          {sendEmailCodeText({
                            EmailAddress: emailAddressToken,
                          })}
                          <PageLink
                            url={Model?.EmailAddressVerificationLink}
                            text={PageData?.GoingBackLinkText}
                            className="u-textWeightBold u-textdecoration"
                          />
                        </p>
                      )}
                    </>
                  )}
                </p>
              </div>
              <form onSubmit={onFormSubmit}>
                <div
                  className={classNames(
                    'form-group',
                    Model?.VerificationFailure && 'error-message',
                  )}
                >
                  <label className={styles.label}>
                    {PageData?.VerifyCodeLabel}
                  </label>
                  <div className={styles.inputsWrapper}>
                    <Controller
                      control={control}
                      name={'FormModel.Code1'}
                      render={({ field: { onChange, name, value } }) => (
                        <OTPInput
                          name={name}
                          value={value}
                          hasError={!!Model?.VerificationFailure}
                          onChange={(e) => handleOTPChange(e, onChange)}
                          onBlur={(e) => formProgression(e, 'Registration', 'Code1')}
                        />
                      )}
                      rules={{
                        required: true,
                      }}
                    />
                    <Controller
                      control={control}
                      name={'FormModel.Code2'}
                      render={({ field: { onChange, name, value } }) => (
                        <OTPInput
                          name={name}
                          value={value}
                          hasError={!!Model?.VerificationFailure}
                          onChange={(e) => handleOTPChange(e, onChange)}
                          onBlur={(e) => formProgression(e, 'Registration', 'Code2')}
                        />
                      )}
                      rules={{
                        required: true,
                      }}
                    />
                    <Controller
                      control={control}
                      name={'FormModel.Code3'}
                      render={({ field: { onChange, name, value } }) => (
                        <OTPInput
                          name={name}
                          value={value}
                          hasError={!!Model?.VerificationFailure}
                          onChange={(e) => handleOTPChange(e, onChange)}
                          onBlur={(e) => formProgression(e, 'Registration', 'Code3')}
                        />
                      )}
                      rules={{
                        required: true,
                      }}
                    />
                    <Controller
                      control={control}
                      name={'FormModel.Code4'}
                      render={({ field: { onChange, name, value } }) => (
                        <OTPInput
                          name={name}
                          value={value}
                          hasError={!!Model?.VerificationFailure}
                          onChange={(e) => handleOTPChange(e, onChange)}
                          onBlur={(e) => formProgression(e, 'Registration', 'Code4')}
                        />
                      )}
                      rules={{
                        required: true,
                      }}
                    />
                    <Controller
                      control={control}
                      name={'FormModel.Code5'}
                      render={({ field: { onChange, name, value } }) => (
                        <OTPInput
                          name={name}
                          value={value}
                          hasError={!!Model?.VerificationFailure}
                          onChange={(e) => handleOTPChange(e, onChange)}
                          onBlur={(e) => formProgression(e, 'Registration', 'Code5')}
                        />
                      )}
                      rules={{
                        required: true,
                      }}
                    />
                    <Controller
                      control={control}
                      name={'FormModel.Code6'}
                      render={({ field: { onChange, name, value } }) => (
                        <OTPInput
                          name={name}
                          value={value}
                          hasError={!!Model?.VerificationFailure}
                          onChange={(e) => handleOTPChange(e, onChange)}
                          onBlur={(e) => formProgression(e, 'Registration', 'Code6')}
                        />
                      )}
                      rules={{
                        required: true,
                      }}
                    />
                  </div>
                  {Model?.VerificationFailure && (
                    <span className={styles.error}>
                      {PageData.IncorrectCodeErrorMessage}
                    </span>
                  )}
                </div>
                <div className="u-marginBxmd">
                  <button
                    type="submit"
                    id="VerifyCodebtn"
                    className={classNames(
                      'Button w-100',
                      (!isValid || isOTPSubmitted == true) && 'Button--gray is-disabled',
                    )}
                    disabled={!isValid || isOTPSubmitted == true}
                  >
                    <span>{PageData?.VerifyCodeButtonLabel}</span>
                  </button>
                </div>
              </form>

              <div className="u-marginBxmd u-textCenter form-text">
                {Model?.IsMobileOtpVerification ? (
                  <button
                    onClick={() =>
                      onResendCode(undefined, Model?.FormModel?.MobileNumber)
                    }
                    className={classNames(
                      'form-text-bold u-textdecoration',
                      (disableResend || Model?.ShowSendingBlockedError) &&
                      styles.disabled,
                    )}
                    disabled={disableResend}
                  >
                    {PageData?.SendCodeAgainLinkText}
                  </button>
                ) : (
                  <button
                    onClick={() => onResendCode(Model?.FormModel?.EmailAddress)}
                    className={classNames(
                      'form-text-bold u-textdecoration',
                      (disableResend || Model?.ShowSendingBlockedError) &&
                      styles.disabled,
                    )}
                    disabled={disableResend}
                  >
                    {PageData?.SendCodeAgainLinkText}
                  </button>
                )}
              </div>
              <div className="u-marginBxsm u-textCenter">
                {showResendSuccess && (
                  <div className={classNames(styles.statusBadge, styles.ok)}>
                    {PageData?.NewCodeSentButtonLabel}
                  </div>
                )}
                {showCounter && (
                  <div
                    className={classNames(styles.statusBadge, styles.blocked)}
                  >
                    <span>
                      {PageData?.RequestANewCodeButtonLabel}
                      <strong className={styles.timer}>
                        {` `}
                        {counter}
                        {` `}
                      </strong>
                      {PageData?.SecondsLabel}
                    </span>
                  </div>
                )}
              </div>
            </div>
            {Model?.FormModel?.VerificationFailureCount === 0 && (
              <div className="auth0-bottom-wrapper">
                <div>
                  <p className="ref-message u-textWeightBold">
                    {PageData?.CodeMayTakeTimeNoteText}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {(showStrugglingPopUp || showResendError) && (
        <div
          id="verifyErrorModal"
          className={classNames(
            'modal-overlay',
            (Model?.ShowStrugglingPopUp || showResendError) && 'is-active',
          )}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <button
                onClick={() => {
                  setShowStrugglingPopUp(false);
                  setShowResendError(false);
                }}
                className="modal-close"
              ></button>
              <div className="modal-header">
                {PageData?.StrugglingToRegisterLabel}
              </div>
              <div className="modal-body u-center">
                <p className="modal-para">
                  {PageData?.StrugglingToRegisterNoteText}
                </p>

                <div>
                  <div>
                    {Model?.IsMobileOtpVerification ? (
                      <PageLink
                        url={Model?.EmailAddressVerificationLink}
                        text={PageData?.TryWithEmailAddressText}
                        className="Button u-block u-marginBxxsm"
                      />
                    ) : (
                      <PageLink
                        url={Model?.MobileNumberVerificationLink}
                        text={PageData?.TryWithMobileNumberText}
                        className="Button u-block u-marginBxxsm"
                      />
                    )}

                    {Model?.IsGoLiveChatEnabled && (
                      <button
                        onClick={() => {
                          liveBtn();
                        }}
                        className={classNames(
                          'Button Button--ghost black-border u-block u-marginBxxsm',
                          styles.fullWidthBtn,
                        )}
                      >
                        <span>{PageData?.GoLiveChatText}</span>{' '}
                      </button>
                    )}
                    {Model?.IsMobileOtpVerification ? (
                      <PageLink
                        url={Model?.MobileNumberVerificationLink}
                        text={PageData?.TryAgainText}
                        className={classNames(
                          'Button Button--ghost gray-border u-block u-marginBxxsm',
                          (Model?.SmsEmailSendingBlocked || showResendError) &&
                          'Button--gray is-disabled',
                        )}
                      />
                    ) : (
                      <PageLink
                        url={Model?.EmailAddressVerificationLink}
                        text={PageData?.TryAgainText || 'Try again'}
                        className={classNames(
                          'Button Button--ghost gray-border u-block u-marginBxxsm',
                          Model?.SmsEmailSendingBlocked &&
                          'Button--gray is-disabled',
                        )}
                      />
                    )}
                    <p
                      id="blockedMessage"
                      className={classNames(
                        'u-textSmall u-textCenter',
                        Model?.SmsEmailSendingBlocked || showResendError
                          ? ''
                          : 'u-hidden',
                      )}
                    >
                      {PageData?.YouAreBlockedTryAgainText}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="modal-overlay" id="myModalContent"></div>
    </>
  );
};

export default RegistrationVerifyOtpPageData;
